<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="150px"
               v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="storageId" label="存油记录">
              <el-select v-model="formData.storageId" :filterable="true" clearable placeholder="请选择存油记录">
                <el-option v-for="(item, index) of storeList"
                           :label="(item.userName || '-') + ` / ${item.warehouseName || '-'} / ` + (item.specName || '-') + ' / ' + (item.manQuantity || 0)"
                           :value="item.id" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="contractAmount" label="合同金额(元)">
              <el-input-number v-model="formData.contractAmount"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="startDate" label="开始计价日期">
              <el-date-picker v-model="formData.startDate" placeholder="请选择开始计价日期" type="date" clearable
                              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="endDate" label="租赁到期时间">
              <el-date-picker v-model="formData.endDate" placeholder="请选择租赁到期时间" type="date" clearable
                              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="dailyRent" label="每日租金单价(元)">
              <el-input-number v-model="formData.dailyRent"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="minimumPrice" label="每日最低收费(元)">
              <el-input-number v-model="formData.minimumPrice"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 新增绩效系数 -->
<!--        <el-row>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item prop="jxRatio" label="绩效系数">-->
<!--              <el-input-number v-model="formData.jxRatio"></el-input-number>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'rentManageAdd',
  data() {
    return {
      formData: {
        storageId: '',
        contractAmount: '',
        startDate: '',
        endDate: '',
        dailyRent: '',
        minimumPrice: '',
        // jxRatio: '',
        fileList: []
      },
      rules: {
        storageId: [
          {
            required: true,
            message: '请选择存油记录',
            trigger: ['blur', 'change']
          }
        ],
        contractAmount: [
          {
            required: true,
            message: '请输入合同金额',
            trigger: ['blur', 'change']
          }
        ],
        startDate: [
          {
            required: true,
            message: '请选择开始计价日期',
            trigger: ['blur', 'change']
          }
        ],
        endDate: [
          {
            required: true,
            message: '请选择租赁到期时间',
            trigger: ['blur', 'change']
          }
        ],
        dailyRent: [
          {
            required: true,
            message: '请输入每日租金单价',
            trigger: ['blur', 'change']
          }
        ],
        minimumPrice: [
          {
            required: true,
            message: '请输入每日最低收费',
            trigger: ['blur', 'change']
          }
        // ],
        // jxRatio: [
        //   {
        //     required: true,
        //     message: '请输入绩效系数',
        //     trigger: ['blur', 'change']
        //   }
        ]
      },
      loading: false,
      ygList: [],
      userList: [],
      storeList: [],
      specList: [],
      currentImageIndex: 0,
      dialogVisible: false
    }
  },
  created() {
    this.loadDict()
    if (this.storageId) {
      this.loadData()
    }
  },
  computed: {
    storageId() {
      return this.$route.query.storageId
    }
  },
  methods: {
    loadDict() {
      // 油罐
      this.$axios.get(this.$apis.oiltabkManage.selectYgInfoByList).then(res => {
        this.ygList = res.list || []
      })

      // 用户
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2'
      }).then(res => {
        this.userList = res.list || []
      })

      // 规格
      this.$axios
        .get(this.$apis.grainSpecifications.selectYxOilSpecByList)
        .then(res => {
          this.specList = res.list || []
        })
      // 存油记录
      this.$axios.get(this.$apis.prodManage.selectLyWareManByPage, {
        isBulkOil: 1
      }).then(res => {
        console.log('datadata', res)
        this.storeList = res.list || []
      })
    },

    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.rentManage.selectYgnCustRentByStorageId, {
          params: { storageId: this.storageId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res || {}
        })
        .finally(() => {
          this.loading = false
        })
    },

    submit() {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.rentManage.insertYgnCustRent
          if (this.storageId) {
            url = this.$apis.rentManage.updateYgnCustRent
          }

          this.$axios.post(url, this.formData).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 900px;
}

::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
